import React from 'react';
import { Box, Container, Typography, Grid, Card, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import { blogPosts } from '../../blogData';
import Seo from '../common/Seo';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Blog = () => {
	const blogJsonLd = {
		'@context': 'https://schema.org',
		'@type': 'Blog',
		name: 'BrokenCosmos Labs Blog',
		url: 'https://brokencosmos.com/blog',
		blogPost: blogPosts.map((post) => ({
			'@type': 'BlogPosting',
			headline: post.title,
			url: `https://brokencosmos.com/blog/${post.slug}`,
			author: {
				'@type': 'Organization',
				name: post.author,
			},
		})),
	};

	return (
		<>
			<Seo
				title="Blog - BrokenCosmos Labs"
				description="Read the latest insights from BrokenCosmos Labs on system integration, software development, and elevating user experiences."
				path="/blog"
				jsonLd={blogJsonLd}
			/>
			<Box
				id="blog"
				sx={{
					py: { xs: 10, md: 15 },
					backgroundColor: 'background.default',
				}}
			>
				<Container maxWidth="lg">
					<Typography
						variant="h2"
						component="h2"
						sx={{
							fontWeight: 700,
							textAlign: 'center',
							mb: 8,
						}}
					>
						Our Blog
					</Typography>
					<Grid container spacing={4}>
						{blogPosts.map((post, index) => (
							<Grid item xs={12} md={4} key={index} sx={{
								animation: `${fadeInUp} 1s ease-out ${index * 0.2}s`,
								animationFillMode: 'forwards',
								opacity: 0,
							}}>
								<Card
									sx={{
										backgroundColor: 'background.paper',
										borderRadius: '1.5rem',
										p: 4,
										display: 'flex',
										flexDirection: 'column',
										justifyContent: 'space-between',
										height: '100%',
										transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
										border: '1px solid',
										borderColor: 'rgba(255, 255, 255, 0.1)',
										'&:hover': {
											transform: 'translateY(-10px)',
											boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
										}
									}}
								>
									<Box>
										<Typography variant="h5" component="h3" sx={{ fontWeight: 600, mb: 1 }}>
											{post.title}
										</Typography>
										<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
											By {post.author} on {post.date}
										</Typography>
										<Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
											{post.excerpt}
										</Typography>
									</Box>
									<Button component={Link} to={`/blog/${post.slug}`} variant="outlined" color="secondary">
										Read More
									</Button>
								</Card>
							</Grid>
						))}
					</Grid>
				</Container>
			</Box>
		</>
	);
};

export default Blog;
//TODO: Add blog posts
